/* Local dependencies */
import { colors } from './colors';

// Semantic colors для компонентов
export const semantic = {
  // Button colors
  button: {
    primary: {
      background: colors.primary,
      backgroundHover: colors.primary_hover,
      backgroundActive: colors.primary_active,
      text: colors.white,
      border: colors.primary,
    },
    secondary: {
      background: 'transparent',
      backgroundHover: colors.background_gray,
      backgroundActive: colors.border_light,
      text: colors.primary,
      border: colors.primary,
    },
    danger: {
      background: colors.error_red,
      backgroundHover: '#e64545',
      backgroundActive: '#cc3d3d',
      text: colors.white,
      border: colors.error_red,
    },
    ghost: {
      background: 'transparent',
      backgroundHover: colors.background_gray,
      backgroundActive: colors.border_light,
      text: colors.text_dark,
      border: 'transparent',
    },
  },

  // Input colors
  input: {
    background: colors.white,
    backgroundDisabled: colors.light_gray,
    border: colors.border_light,
    borderHover: colors.text_gray,
    borderFocus: colors.primary,
    borderError: colors.error_red,
    text: colors.text_dark,
    textDisabled: colors.gray,
    placeholder: colors.text_gray,
  },

  // Text colors
  text: {
    primary: colors.text_dark,
    secondary: colors.text_gray,
    disabled: colors.gray,
    inverse: colors.white,
    link: colors.primary,
    linkHover: colors.primary_hover,
    success: colors.success_green,
    error: colors.error_red,
    warning: '#FF9800',
    info: colors.info_blue,
  },

  // Background colors
  background: {
    primary: colors.white,
    secondary: colors.light_gray,
    tertiary: colors.background_gray,
    dark: colors.soft_black,
    overlay: 'rgba(0, 0, 0, 0.5)',
    modalOverlay: 'rgba(0, 0, 0, 0.7)',
  },

  // Border colors
  border: {
    default: colors.border_light,
    light: '#e5e5e5',
    medium: colors.dark_gray,
    dark: colors.text_gray,
    primary: colors.primary,
    error: colors.error_red,
    success: colors.success_green,
  },

  // Status colors
  status: {
    success: {
      background: '#f0fdf4',
      border: colors.success_green,
      text: '#166534',
    },
    error: {
      background: '#fef2f2',
      border: colors.error_red,
      text: '#991b1b',
    },
    warning: {
      background: '#fffbeb',
      border: '#f59e0b',
      text: '#92400e',
    },
    info: {
      background: '#eff6ff',
      border: colors.info_blue,
      text: '#1e40af',
    },
  },

  // Card colors
  card: {
    background: colors.white,
    backgroundHover: colors.background_gray,
    border: colors.border_light,
    shadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  },
};

